export default __webpack_public_path__ + "static/media/1486.ffc583ac.png";